import { particles } from 'app/contracts/Particles';
import { geometry } from 'app/contracts/Geometry';

export class ScreenTarget implements particles.ParticleTarget {
	private _sceneProps: particles.SceneProps;
	private _targetPoint: geometry.Vector2;

	constructor(targetPoint: geometry.Vector2) {
		this._targetPoint = targetPoint;
	}

	public set sceneProps(v: particles.SceneProps) {
		this._sceneProps = v;
	}

	public get position(): geometry.Vector2 {
		return {
			x: this._targetPoint.x * this._sceneProps.sizes.window.w,
			y: this._targetPoint.y * this._sceneProps.sizes.window.h
		};
	}

	public get relativePosition(): geometry.Vector2 {
		//Return the relative position converted to absolute cords:
		//TODO logic needs implementation:
		return {
			x: (this._targetPoint.x * this._sceneProps.sizes.window.w) / this._sceneProps.sizes.container.w,
			y: (this._targetPoint.y * this._sceneProps.sizes.window.h) / this._sceneProps.sizes.container.h
		};
	}
}
